import { twMerge } from 'tailwind-merge'
import { Panel } from '~/components/ui'
import { TradeListing } from '../api/trade'

/** One NFT for sale.
 *
 *  The price is the largest thing on the card because it is the number the
 *  buyer is agreeing to, and it is the number the server will check against
 *  what they submit. */
export const ListingCard = ({
    listing,
    onBuy,
    busy,
    disabled,
}: {
    listing: TradeListing
    onBuy?: (listing: TradeListing) => void
    busy?: boolean
    disabled?: boolean
}) => (
    <Panel className='flex flex-col'>
        <div className='relative aspect-square w-full overflow-hidden bg-white/[0.03]'>
            {listing.nft.image_url ? (
                <img
                    src={listing.nft.image_url}
                    alt={listing.nft.name}
                    loading='lazy'
                    className='h-full w-full object-contain'
                />
            ) : (
                <div className='flex h-full items-center justify-center text-xs uppercase tracking-widest text-white/30'>
                    No image
                </div>
            )}
            {listing.nft.rank != null && (
                <span className='absolute left-2 top-2 bg-black/70 px-2 py-1 text-[10px] font-black uppercase tracking-widest text-white/70'>
                    Rank {listing.nft.rank}
                </span>
            )}
        </div>

        <div className='flex flex-1 flex-col gap-3 p-3'>
            <div className='min-w-0'>
                <p className='truncate text-sm font-bold text-white'>{listing.nft.name}</p>
                <p className='truncate text-[11px] uppercase tracking-widest text-white/40'>
                    {listing.seller.username}
                </p>
            </div>

            <div className='mt-auto flex items-end justify-between gap-2'>
                <div>
                    <p className='text-[10px] uppercase tracking-widest text-white/40'>Price</p>
                    <p className='text-lg font-black text-white'>${listing.price}</p>
                </div>
                {onBuy && (
                    <button
                        onClick={() => onBuy(listing)}
                        disabled={busy || disabled}
                        className={twMerge(
                            'min-h-[2.25rem] bg-[#03CEFF] px-4 text-xs font-black uppercase tracking-[0.15em] text-black transition-[filter]',
                            'hover:brightness-110 disabled:opacity-40 disabled:hover:brightness-100'
                        )}
                    >
                        {busy ? 'Buying…' : 'Buy'}
                    </button>
                )}
            </div>
        </div>
    </Panel>
)
